import apiClient from '../../api/apiClient';

export const updateLogoApi = async (logoData) => {
  const formData = new FormData();
  formData.append('logo', logoData.file);
  formData.append('_id', logoData._id);

  const response = await apiClient.putFormData('/partners/itsales-partner/logo', formData);
  return response.data;
};